import React, { type ReactNode } from 'react';
import type { FieldType } from '../../../types/EvalancheTypes';
import { Container, Input, FormLabel, ErrorMessage } from '../styles';

// TODO: Figure out how to use FormikProps type with dynamic field type
export const TextInput = ({
  field,
  formikProps,
  isHidden = false,
}: {
  field: FieldType;
  formikProps: any;
  isHidden?: boolean;
}): ReactNode => (
  <Container className={isHidden ? 'hidden' : ''}>
    {!field.hidden && (
      <FormLabel tag="span" type="lead" className="text-gray-500">
        {field.label}
      </FormLabel>
    )}
    <Input
      type="text"
      readOnly={field.readonly}
      name={field.name}
      required={field.required}
      onChange={formikProps.handleChange}
      value={formikProps.values[field.name]}
      data-test={`text-${field.name}`}
      hidden={field.hidden}
    />
    {formikProps.errors[field.name] && (
      <ErrorMessage data-test={`text-${field.name}-error`}>
        {formikProps.errors[field.name]}
      </ErrorMessage>
    )}
  </Container>
);
